<template>
    <el-dialog title="照片" :close-on-click-modal="false" :visible.sync="visible" width="1000px">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="155px" :inline="true"
            class="border-form" style="margin-right: 25px;margin-top: -15px;">
            <!-- <el-row class="set_border">
                <el-col :span="12" class="col-set_border">
                    <el-form-item label="标的物" class="item">
                        <span class="set_data">{{ dataForm.subjectName }}</span>
                    </el-form-item>
                </el-col> -->
            <!-- <el-col :span="8" class="set_border">
                    <el-form-item label="范畴" class="item">
                        {{ dataForm.categoryName }}
                    </el-form-item>
                </el-col> -->
            <!-- <el-col :span="12">
                    <el-form-item label="专业" class="item">
                        <span class="set_data">{{ dataForm.majorName }}</span>
                    </el-form-item>
                </el-col>
            </el-row> -->
            <!-- <el-row class="set_border">
                <el-col :span="12" class="col-set_border">
                    <el-form-item label="提出人" class="item">
                        <span class="set_data">{{ dataForm.inspectionMan }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="提出时间" class="item">
                        <span class="set_data">{{ dataForm.inspectionTime | formatDate('yyyy-MM-dd') }}</span>
                    </el-form-item>
                </el-col>
            </el-row> -->
            <!-- <el-row class="set_border">
                <el-col :span="24">
                    <el-form-item label="巡检内容" class="item">
                        <span class="set_data">{{ dataForm.inspectionContent }}</span>
                    </el-form-item>
                </el-col>
            </el-row> -->
            <!-- <el-row class="set_border">
                <el-col :span="24">
                    <el-form-item label="问题描述及整改意见（如有时）" class="item">
                        <span class="set_data">{{ dataForm.sutContent }}</span>
                    </el-form-item>
                </el-col>
            </el-row> -->
            <!-- <el-row class="set_border">
                <el-col :span="12" class="col-set_border">
                    <el-form-item label="封闭人" class="item">
                        <span class="set_data">{{ dataForm.closeMan }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="封闭时间" class="item">
                        <span class="set_data">{{ dataForm.closeTime | formatDate('yyyy-MM-dd') }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="set_border">
                <el-col :span="24">
                    <el-form-item label="备注" class="item">
                        <span class="set_data">{{ dataForm.remark }}</span>
                    </el-form-item>
                </el-col>
            </el-row> -->

            <el-row>
                <el-col :span="24" class="row-form-item">
                    <el-form-item label="巡检内容" class="fileItem">
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="set_border">
                <el-col :span="24">
                    <span class="set_data">{{ dataForm.inspectionContent }}</span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" class="row-form-item">
                    <el-form-item label="问题描述及整改意见（如有时）" class="fileItem">
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="set_border">
                <el-col :span="24">
                    <span class="set_data">{{ dataForm.sutContent }}</span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" class="row-form-item">
                    <el-form-item label="现场照片（如有时）" class="fileItem">
                    </el-form-item>
                </el-col>
                <el-col :span="24" style="margin-top: 10px;">
                    <el-upload ref="uploadImg" class="upload-demo" action="action" drag :http-request="uploadImg" :before-upload="beforeUploadSituation"
                        multiple :show-file-list=false :auto-upload="true" accept="image/jpeg,image/png,image/jpg">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                </el-col>
                <el-col :span="24" style="margin-top: 30px;margin-bottom: 10px;">
                    <el-table class="dataListTable" border header-align="center"
                        v-if="dataForm.scenePhotoList.length > 0" :data="dataForm.scenePhotoList" style="width: 100%;"
                        :cell-style="{ padding: '0px' }">
                        <el-table-column type="index" label="No." width="60" header-align="center" align="center">
                        </el-table-column>
                        <el-table-column label="图片" width="220" header-align="center">
                            <template slot-scope="scope">
                                <el-image style="height: 100px" :src="scope.row.thumbnailPathUri"
                                    :preview-src-list="previewList(scope.row.thumbnailPathUri)"
                                    fit='contain'></el-image>
                            </template>
                        </el-table-column>
                        <el-table-column label="描述" width="450px" header-align="center">
                            <template slot-scope="scope">
                                <el-input type="textarea" rows="2"
                                    v-model="dataForm.scenePhotoList[scope.$index].fileContent"
                                    placeholder="请填写"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label=" " width="103" align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" type="danger" @click="delScenePhoto(scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column label="同步" width="80" header-align="center" align="center">
                            <template slot-scope="scope">
                                <el-checkbox :value="scope.row.synchroFlg === 1"
                                    @change="(val) => (scope.row.synchroFlg = val ? 1 : 0)" class="sbox"
                                    label=""></el-checkbox>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
            <el-row class="formBtnGroup">
                <el-button v-preventReClick class="btn" type="primary" size="small"
                    @click="dataFormSubmit()">确定</el-button>
                <el-button v-preventReClick class="btn" type="primary" size="small"
                    @click="visible = false">取消</el-button>
            </el-row>
        </el-form>
    </el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
import { Checkbox } from "element-ui";
export default {
    name: "patrolList-add-or-update",
    data() {
        return {
            inspectionId: '',
            dataForm: {
                scenePhotoList: [],
                closeFileList: [],
                closePhotoList: [],
                inspectionId: ''
            },
            dataRule: {},
            visible: false
        };
    },
    components: {

    },
    activated() {

    },
    filters: {
        formatDate: function (value, args) {
            if (!value) {
                return ''
            }
            var dt = new Date(value);
            if (args == 'yyyy-M-d') {// yyyy-M-d
                let year = dt.getFullYear();
                let month = dt.getMonth() + 1;
                let date = dt.getDate();
                return `${year}-${month}-${date}`;
            } else if (args == 'yyyy-M-d H:m:s') {// yyyy-M-d H:m:s
                let year = dt.getFullYear();
                let month = dt.getMonth() + 1;
                let date = dt.getDate();
                let hour = dt.getHours();
                let minute = dt.getMinutes();
                let second = dt.getSeconds();
                return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
            } else if (args == 'yyyy-MM-dd') {// yyyy-MM-dd
                let year = dt.getFullYear();
                let month = (dt.getMonth() + 1).toString().padStart(2, '0');
                let date = dt.getDate().toString().padStart(2, '0');
                return `${year}-${month}-${date}`;
            } else {// yyyy-MM-dd HH:mm:ss
                let year = dt.getFullYear();
                let month = (dt.getMonth() + 1).toString().padStart(2, '0');
                let date = dt.getDate().toString().padStart(2, '0');
                let hour = dt.getHours().toString().padStart(2, '0');
                let minute = dt.getMinutes().toString().padStart(2, '0');
                let second = dt.getSeconds().toString().padStart(2, '0');
                return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
            }
        }
    },
    methods: {
        init(id) {
            this.inspectionId = id;
            this.visible = true;
            this.dataForm = {
                scenePhotoList: [],
                closeFileList: [],
                closePhotoList: [],
                inspectionId: this.inspectionId
            }
            this.getDetail(id)
        },
        // getDetail() {
        //     this.$http({
        //         url: this.$store.state.httpUrl + "/business/inspectionfile/list/" + this.inspectionId,
        //         method: "get",
        //         params: {},
        //     }).then(({ data }) => {
        //         if (data && data.resultCode === 200) {
        //             this.dataForm = data.body
        //         }
        //     });
        // },
        beforeUploadSituation(file) {
			const isValidType = file.type === 'image/jpeg' ||
				file.type === 'image/png' ||
				file.type === 'image/jpg'

			if (!isValidType) {
				this.$message.error('只能上传 JPG/PNG 格式的图片！')
				return false
			}
			return true
		},
        selectFile(url, filename) {
            filename = this.getSuffix(url, filename)
            this.getBlob(url, (blob) => {
                this.saveAs(blob, filename)
            })
        },
        getSuffix(url, filename) {
            let lastIndex = url.lastIndexOf(".");
            return filename + url.substr(lastIndex)
        },
        getBlob(url, cb) {
            var xhr = new XMLHttpRequest()
            xhr.open('GET', url, true)
            xhr.responseType = 'blob'
            xhr.onload = function () {
                if (xhr.status === 200) {
                    cb(xhr.response)
                }
            }
            xhr.send()
        },
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename)
            }
            else {
                var link = document.createElement('a')
                var body = document.querySelector('body')

                link.href = window.URL.createObjectURL(blob)
                link.download = filename

                link.style.display = 'none'
                body.appendChild(link)

                link.click()
                body.removeChild(link)
                window.URL.revokeObjectURL(link.href)
            }
        },
        getDetail() {
            this.$http({
                url: this.$store.state.httpUrl + "/business/inspectioninfo/info/" + this.inspectionId,
                method: "get",
                params: {},
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.dataForm = data.body;
                    if (!this.dataForm.inspectionMan) {
                        this.dataForm.inspectionMan = $common.getItem("userName");
                    }
                }
            });
        },
        // 删除现场照片
        delScenePhoto(index) {
            let _scenePhotoList = this.dataForm.scenePhotoList;
            _scenePhotoList.splice(index, 1);
            this.dataForm.scenePhotoList = _scenePhotoList;
        },
        // 上传照片
        uploadImg(param) {
            const formData = new FormData();
            formData.append('file', param.file);
            this.$refs.uploadImg.clearFiles();
            this.$http.post(
                this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/10/0",
                formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            },
            ).then(res => {
                res = res.data
                if (res.resultCode == 200) {
                    this.dataForm.scenePhotoList.push({
                        inspectionId: this.inspectionId,
                        recFileType: '0',
                        fileName: res.body.fileName,
                        filePath: res.body.fileSavePath,
                        fileUri: res.body.fileUri,
                        fileContent: this.extractFileName(res.body.fileName),
                        thumbnailPath: res.body.thumbnailPath,
                        thumbnailPathUri: res.body.thumbnailPathUri,
                        compressedPath: res.body.compressedPath,
                        synchroFlg: '0'
                    });
                } else {
                    this.$message.info('文件上传失败')
                }
            })
        },
        previewList(fileUri) {
            return [fileUri]
        },
        extractFileName(fileName) {
            let index = fileName.lastIndexOf(".");
            return fileName.substr(0, index)
        },
        dataFormSubmit() {
            this.dataForm.inspectionId = this.inspectionId
            let _url = "/business/inspectionfile/save";
            this.$http({
                url: this.$store.state.httpUrl + _url,
                method: "post",
                data: this.$http.adornData(this.dataForm)
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                        onClose: () => {
                            this.visible = false;
                        }
                    });
                }
            });
        }
    }
};
</script>

<style scoped="scoped">
.addImgBox {
    width: 180px;
    height: 180px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 23px;
}

.set_title {
    margin-left: 10px;
    margin-bottom: 10px;
}

::v-deep(.upload-demo .el-upload-dragger) {
    width: 915px;
    height: 100px;
    margin-bottom: -30px;
}

::v-deep(.upload-demo .el-upload-dragger .el-icon-upload) {
    font-size: 30px;
    margin: 20px 1px;
    line-height: 20px;
}

::v-deep(.upload-demo .el-upload-dragger .el-upload__text) {
    line-height: 5px;
}

.sp-input /deep/ .el-input__inner {
    width: 100% !important;
}

.item::v-deep .el-form-item__label {
    color: #00428e !important;
    margin-right: 10px !important;
    font-weight: bold !important;
    align-items: center;
    background-color: #E1F1FF !important;
    border-right: 1px solid #dadada !important;
    white-space: normal;
    font-size: 12px !important;
    word-break: break-all;
}

::v-deep .el-form-item {
    display: flex !important;
    align-items: stretch !important;
    margin-bottom: 0px !important;
}

.item::v-deep .el-form-item__content {
    display: flex;
    align-items: center;
    white-space: normal;
    word-break: break-all;
    flex: 1;
    font-size: 12px !important;
    padding: 2px 0 !important;
    /* 减少内边距 */
    line-height: 1.4;
    /* 设置统一的行高 */
}

.fileItem::v-deep .el-form-item__label {
    text-align: left;
    margin: 0px 0px !important;
    color: #00428e !important;
    font-weight: bold !important;
    width: 100% !important;
    max-height: 20px !important;
    background-color: #E1F1FF !important;
    display: flex;
    align-items: center;
}

.border-form .el-row.set_border {
    border-right: 0.5px solid #dadada;
    border-bottom: 0.5px solid #dadada;
    border-left: 0.5px solid #dadada;
}

/* .border-form .el-row.set_border:first-child {
    border-top: 0.5px solid #dadada;
}

.border-form .el-row.set_border .col-set_border {
    border-right: 0.5px solid #dadada;
} */

::v-deep .el-dialog__header {
    height: 60px;
    line-height: 30px;
}

.set_data {
    font-size: 14px;
    padding: 5px 10px !important;
    width: 100% !important;
}

.row-form-item {
    border: 0.5px solid #dadada;
}

.fileItem {
    padding-left: 10px !important;
}

.sbox::v-deep .el-checkbox__inner::after {
    margin-left: 1px;
}
</style>
